module.exports = __webpack_public_path__ + "static/img/h_15@2x.13e965a2.png";